import { SortItem } from "@models/ss-api/responses/member.dashboard.license.response";
import { ISortable } from "app/helpers/sort";

export class UpdateSuccess {
    MemberID: number;
    DesignerName: string;
    FullAddress: string;
    LicenseKey: string;
    VersionInt: number;
    FromVersionInt: number;
    IsResume: boolean;
    FormattedVersionInt: string;
    FormattedFromVersionInt: string;
    DateTimeCreated: Date;
    DynamicallyLoaded: boolean;

    static FixDate(item: UpdateSuccess) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    } 
}

export class UpdateSuccessArray extends Array<UpdateSuccess> implements ISortable {

    public LastSort = new SortItem;
    
    constructor(...items: UpdateSuccess[]) {
        super(...items);
        Object.setPrototypeOf(this, UpdateSuccessArray.prototype);
    }

    static FixDates(items: UpdateSuccessArray) {
        items.forEach(x => UpdateSuccess.FixDate(x));
    }

}
